import React from 'react';
import './styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faFileInvoice, faListCheck, faPersonRunning } from '@fortawesome/free-solid-svg-icons';
import { Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CommentsDocsActionsIconWrapper = (props: any) => {
    const { actions, docs, comments, tasks, showDetailedCount, jlComments, clubComments } = props;
    const [t] = useTranslation();

    return(
        <div>
            {
                (comments != undefined && comments != null) &&
                <span>
                    <Typography className='countLabel fs12'>{comments ? comments : 0}</Typography>
                    {
                        showDetailedCount ? 
                        <Tooltip title={`${jlComments} ${t('JL_COMMENTS')} , ${clubComments} ${t('CLUB_COMMENTS')}`} arrow placement='top'>
                            <FontAwesomeIcon className='triIcons icon' icon={faComments} />    
                        </Tooltip> :
                        <FontAwesomeIcon className='triIcons icon' icon={faComments} />
                    }
                </span>
            }
            {
                (docs != undefined && docs != null) &&
                <span>
                    <Typography className='countLabel fs12'>{docs ? docs : 0}</Typography>
                    <FontAwesomeIcon className='triIcons icon' icon={faFileInvoice} />
                </span>
            }
            {
                (actions != undefined && actions != null) &&
                <span>
                    <Typography className='countLabel fs12'>{actions ? actions : 0}</Typography>
                    <FontAwesomeIcon className='triIcons icon' icon={faPersonRunning} />
                </span>
            }
            {
                (tasks != undefined && tasks != null) &&
                <span>
                    <Typography className='countLabel fs12'>{tasks ? tasks : 0}</Typography>
                    <FontAwesomeIcon className='triIcons icon' icon={faListCheck} />
                </span>
            }
        </div>
    )
}

export default CommentsDocsActionsIconWrapper;